export const milestones = {
    CORNER: {
        team: 4,
        data: {
            label: 'Corners'
        }
    },
    FREE_KICK: {
        stat: 'fouls',
        player: 2,
        team: 4,
        data: {
            label: 'Fouls'
        }
    },
    PENALTY_AWARDED: {
        stat: 'fouls',
        player: 1,
        team: 1,
        data: {
            label: 'Penalty Awarded'
        }
    },
    PENALTY_MISSED: {
        player: 1,
        team: 1,
        data: {
            label: 'Penalty Missed'
        }
    },
    /*SHOT_OFF_TARGET: {
      stat: 'totalShots',
      player: 2,
      team: 5,
      data: {
        label: 'Shots On Target'
      }
    },*/
    SHOT_ON_TARGET: {
        stat: 'shotsOnTarget',
        player: 2,
        team: 5,
        data: {
            label: 'Shots On Target'
        }
    },
    OFFSIDE: {
        player: 2,
        team: 3
    }
};
//# sourceMappingURL=milestones.js.map